export const chartColors = [
  '#1060FF', // Primary Blue
  '#FF7F0E', // Orange
  '#2CA02C', // Green
  '#D62728', // Red
  '#9467BD', // Purple
  '#8C564B', // Brown
  '#E377C2', // Pink
  '#7F7F7F', // Gray
  '#BCBD22', // Olive
  '#17BECF', // Cyan
  '#FFBB78', // Light Orange
  '#FF9896', // Light Red
  '#98DF8A', // Light Green
  '#F7B6D2', // Light Pink
  '#C5B0D5', // Light Purple
  '#C49C94', // Light Brown
  '#DBDB8D', // Light Olive
  '#9EDAE5', // Light Cyan
  '#FBB4AE', // Light Coral
  '#B3DE69', // Light Lime
  '#FFDDC1', // Light Peach
];
